import styles from "../styles/home.module.scss";

const Features = () => {
    return ( 
        <div className={styles["Feature-container"]}>
        <div className={styles["title"]}>Features</div>
        <div className={styles["inner-container"]}>
            <div className={styles["titl"]}>Currently avaliable template include:</div>
            <ul>
                <li>vanilla</li>
                <li>vanilla-ts</li>
                <li>react</li>
                <li>react-ts</li>
            </ul>
            <em>This will be updated with more templates.</em>
        </div>

        </div>
     );
}
 
export default Features;